// This file is used to register a service worker for the Gatsby site.
// It intended purpose is simply to kill-off any old service workers that may be lingering around from legacy EPI2ME portal.

export const onClientEntry = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW Cleanup] Registered cleanup service worker');

        // Optional: force immediate update if another SW is in control
        registration.update();
      })
      .catch((error) => {
        console.warn('[SW Cleanup] Failed to register service worker:', error);
      });

    // Also: try to unregister any old SWs not under our scope
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => {
        if (!reg.active?.scriptURL.includes('sw.js')) {
          console.log('[SW Cleanup] Unregistering unknown service worker:', reg);
          reg.unregister();
        }
      });
    });
  }
};
